import type { EmployerSiteName } from 'src/types';

const ENABLED_COUNTRIES = ['au', 'nz'] as string[];
const ENABLED_SITES = [
  'employer-seek-au',
  'employer-seek-nz',
] as EmployerSiteName[];

export const shouldRenderMultiLocationInSite = (siteName: EmployerSiteName) =>
  ENABLED_SITES.includes(siteName);

export const shouldRenderMultiLocationInJobLocationCountry = (
  jobLocationCountry?: string,
) =>
  jobLocationCountry &&
  ENABLED_COUNTRIES.includes(jobLocationCountry.toLowerCase());
